import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/dbSelector';

const selectAllSeats = createSelector(
    orm,
    dbSelector,
    ({ Seat }) => {
        const seats = Seat.all();
        seats.toModelArray(); // resetting cache
        return seats;
    },
);

export default selectAllSeats;
